import React from "react";
import PropTypes from 'prop-types';

const Icon = ({ color="orange", ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="none"
            viewBox="0 0 14 14"
        >
            <circle cx="7" cy="7" r="7" fill={color}></circle>
        </svg>
    );
}

Icon.propTypes = {
    color: PropTypes.string
};

export default Icon;